<template>
    <div class="private">
      <private-container></private-container>
    </div>
</template>
<script>
import PrivateContainer from '@/components/private/Container.vue'
export default {
  name: 'private',
  components: {
    PrivateContainer
  }
}
</script>
<style lang="stylus">
.private
  height 100%
</style>
